<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8" />
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <LiveGamesTable
            title="Live Games"
            :data="livegames"
            @create="modals.addGame = true"
            @edit="openEditModal"
            @remove="openRemoveModal"
          />
        </div>
      </div>
    </div>

    <modal :show.sync="modals.addGame">
      <h4 slot="header" class="modal-title" id="modal-title-default">+ New Game</h4>
      <div class="row">
        <div class="col-12">
          <base-input
            alternative=""
            label="Name"
            input-classes="form-control-alternative"
            v-model="model.name"
            :error="errors.name"
          />
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Active
          </label><br />
          <base-switch v-model="model.active"></base-switch>
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Round Scores
          </label><br />
          <base-switch v-model="model.roundScores"></base-switch>
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Sort Scores Low to High
          </label><br />
          <base-switch v-model="model.sortLowToHigh"></base-switch>
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Show Plus Signs
          </label><br />
          <base-switch v-model="model.showPlusSigns"></base-switch>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          @click="modals.addGame = false"
        >
          Cancel
        </base-button>
        <base-button
          type="success"
          class="ml-auto"
          @click="createGame"
        >
          Create Game
        </base-button>
      </template>
    </modal>

    <modal
      :show.sync="modals.editGame"
    >
      <h4
        slot="header"
        class="modal-title"
        id="modal-title-default"
      >
        Edit {{editModel.name}}
      </h4>
      <div class="row">
        <div class="col-12">
          <base-input
            alternative=""
            label="Name"
            input-classes="form-control-alternative"
            v-model="editModel.name"
            :error="errors.name"
          />
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Active
          </label><br />
          <base-switch v-model="editModel.active" />
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Round Scores
          </label><br />
          <base-switch v-model="editModel.roundScores"></base-switch>
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Sort Scores Low to High
          </label><br />
          <base-switch v-model="editModel.sortLowToHigh"></base-switch>
        </div>
        <div class="col-6">
          <label class="form-control-label">
            Show Plus Signs
          </label><br />
          <base-switch v-model="editModel.showPlusSigns"></base-switch>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          @click="modals.editGame = false"
        >
          Cancel
        </base-button>
        <base-button
          type="success"
          class="ml-auto"
          @click="editGame"
        >
          Save
        </base-button>
      </template>
    </modal>

    <modal
      :show.sync="modals.removeGame"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>This will discard the game and all of its scores.</p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="removeGame"
        >
          Discard
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.removeGame = false"
        >
          Stay
        </base-button>
      </template>
    </modal>

  </div>
</template>
<script>
import LiveGamesTable from '@/views/LiveGames/Tables/LiveGamesTable.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  components: {
    LiveGamesTable,
  },
  data() {
    return {
      livegames: [],
      modals: {
        addGame: false,
        editGame: false,
        removeGame: false,
      },
      model: {
        name: '',
        active: false,
        roundScores: true,
        showPlusSigns: true,
        sortLowToHigh: true,
      },
      errors: {
        name: '',
      },
      editModel: {
        name: '',
        active: false,
        id: -1,
        roundScores: true,
        showPlusSigns: true,
        sortLowToHigh: true,
      },
      gameToRemove: null,
    };
  },
  sockets: {
    new_game(data) {
      this.livegames.push(data);
    },
    updated_game(data) {
      let foundIndex = -1;
      this.livegames.forEach((game, index) => {
        if (parseInt(game.id, 10) === parseInt(data.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        console.log(foundIndex);
        this.livegames.splice(foundIndex, 1, data);
      }
    },
    deleted_game(data) {
      let foundIndex = -1;
      this.livegames.forEach((game, index) => {
        if (parseInt(game.id, 10) === parseInt(data.id, 10)) {
          foundIndex = index;
        }
      });

      if (foundIndex >= 0) {
        console.log(foundIndex);
        this.livegames.splice(foundIndex, 1);
      }
    },
    new_team(data) {
      if (!data.livegame) {
        return;
      }
      this.livegames.forEach((game, index) => {
        if (parseInt(game.id, 10) === parseInt(data.livegame.id, 10)) {
          this.livegames[index].liveteams.push(data);
        }
      });
    },
    updated_team(data) {
      if (!data.livegame) {
        return;
      }

      this.livegames.forEach((game, gameIndex) => {
        let indexToRemove = -1;
        game.liveteams.forEach((team, teamIndex) => {
          if (parseInt(team.id, 10) === parseInt(data.id, 10)) {
            indexToRemove = teamIndex;
          }
        });

        if (indexToRemove >= 0) {
          this.livegames[gameIndex].liveteams.splice(indexToRemove, 1);
        }

        if (parseInt(game.id, 10) === parseInt(data.livegame.id, 10)) {
          console.log(game);
          this.livegames[gameIndex].liveteams.push(data);
        }
      });
    },
    deleted_team(data) {
      this.livegames.forEach((game, gameIndex) => {
        let indexToRemove = -1;
        game.liveteams.forEach((team, teamIndex) => {
          if (parseInt(team.id, 10) === parseInt(data.id, 10)) {
            indexToRemove = teamIndex;
          }
        });

        if (indexToRemove >= 0) {
          this.livegames[gameIndex].liveteams.splice(indexToRemove, 1);
        }
      });
    },
  },
  mounted() {
    this.getGames();
  },
  methods: {
    removeGame() {
      this.axios
        .delete(`/livegames/${this.gameToRemove.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.modals.removeGame = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    openRemoveModal(game) {
      this.gameToRemove = game;
      this.modals.removeGame = true;
    },
    editGame() {
      if (!this.checkEditErrors()) {
        return;
      }
      const newGame = {
        name: this.editModel.name,
        active: this.editModel.active,
        roundScores: this.editModel.roundScores,
        sortLowToHigh: this.editModel.sortLowToHigh,
        showPlusSigns: this.editModel.showPlusSigns,
      };

      this.axios
        .put(`/livegames/${this.editModel.id}`, newGame, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.modals.editGame = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    openEditModal(game) {
      this.editModel.name = game.name;
      this.editModel.active = game.active;
      this.editModel.roundScores = game.roundScores;
      this.editModel.sortLowToHigh = game.sortLowToHigh;
      this.editModel.showPlusSigns = game.showPlusSigns;
      this.editModel.id = game.id;

      this.modals.editGame = true;
    },
    checkErrors() {
      this.errors.name = '';
      let result = true;

      if (this.model.name === '') {
        this.errors.name = 'This field is required.';
        result = false;
      }

      return result;
    },
    checkEditErrors() {
      this.errors.name = '';
      let result = true;

      if (this.editModel.name === '') {
        this.errors.name = 'This field is required.';
        result = false;
      }

      return result;
    },
    getGames() {
      this.axios
        .get('/livegames', {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          console.log(response.data);
          this.livegames = response.data;
        });
    },
    createGame() {
      if (!this.checkErrors()) {
        return;
      }
      const newGame = {
        name: this.model.name,
        active: this.model.active,
        roundScores: this.model.roundScores,
        sortLowToHigh: this.model.sortLowToHigh,
        showPlusSigns: this.model.showPlusSigns,
      };

      this.axios
        .post('/livegames', newGame, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then(() => {
          this.modals.addGame = false;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
  },
  watch: {
    modals: {
      handler(value) {
        if (!value.addGame) {
          this.model.name = '';
          this.model.active = false;
          this.model.roundScores = true;
          this.model.sortLowToHigh = true;
          this.model.showPlusSigns = true;
        }
        if (!value.editGame) {
          this.editModel.name = '';
          this.editModel.active = false;
          this.editModel.id = -1;
          this.editModel.roundScores = true;
          this.editModel.sortLowToHigh = true;
          this.editModel.showPlusSigns = true;
        }
      },
      deep: true,
    },
  },
};
</script>
